import { OPEN_USER_PROMPT } from '../../../actions/actionTypes';
import { isCompanyAdmin, isAdmin } from '../../../lib/tools';

/**
 * ユーザー配列の中に企業管理者または管理者権限のユーザーが含まれているかどうかを判定する
 * @param {*} selectedUserIds - 判定対象のユーザーIDの配列
 * @param {*} companyAllUsers - 企業に紐づく全てのユーザーの配列
 * @returns
 */
const hasAdminUser = (selectedUserIds, companyAllUsers) =>
  selectedUserIds.some(userId => {
    const user = companyAllUsers.find(u => u.guid === userId);
    return user && (isCompanyAdmin(user.role) || isAdmin(user.role));
  });

/**
 * ユーザー権限をチェックし、企業管理者または、管理者権限のユーザーが含まれていない場合にエラーダイアログを表示する関数
 * @param {Object[]} selectedUserIds - 選択されているユーザーIDの配列
 * @param {Object[]} companyAllUsers - 企業に紐づく全てのユーザーの配列
 * @param {Function} dispatch - reduxのdispatch関数
 * @param {Function} formatMessage - i18nのformatMessage関数
 * @returns
 */
export const checkAdminUser = (
  selectedUserIds,
  companyAllUsers,
  dispatch,
  formatMessage,
) => {
  if (!hasAdminUser(selectedUserIds, companyAllUsers)) {
    const promptMessage = formatMessage({
      id: 'userPrompt.message.group.noCorporateAdmin',
    });
    const buttonClose = formatMessage({ id: 'userPrompt.button.close' });

    dispatch({
      type: OPEN_USER_PROMPT,
      promptMessage: [promptMessage],
      buttonArray: [{ name: buttonClose, type: 0 }],
    });
    return false;
  }
  return true;
};

export default checkAdminUser;
